const unsubscribeActionConstants = {
  UNSUBSCRIBE_REFERRAL_ROUNDUP: 'UNSUBSCRIBE_REFERRAL_ROUNDUP',
  UNSUBSCRIBE_REFERRAL_ROUNDUP_SUCCESS: 'UNSUBSCRIBE_REFERRAL_ROUNDUP_SUCCESS',
  UNSUBSCRIBE_REFERRAL_ROUNDUP_ERROR: 'UNSUBSCRIBE_REFERRAL_ROUNDUP_ERROR',
};

export default unsubscribeActionConstants;
